import * as yup from "yup";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  appointmentId: yup.number().required(),
});

export function useAppointmentUncheckMutation(options = {}) {
  const queryClient = useQueryClient();

  return useMutation(
    (payload) => {
      var req = requestSchema.validateSync(payload, { strict: true });

      return http.post(HTTP_ENDPOINTS.appointments.uncheck(req.appointmentId));
    },
    {
      ...options,
      onSuccess: (...args) => {
        [
          QUERY_KEYS.appointments.appointment,
          QUERY_KEYS.appointments.checkin,
        ].forEach((key) => {
          queryClient.invalidateQueries({
            queryKey: [key],
          });
        });
        options.onSuccess?.(...args);
      },
    },
  );
}
